import type { SVGProps } from 'react'
const SvgSyCronos = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141.7 141.7" width={24} height={24} {...props}>
		<path d="M70.9 2.8 12 36.9v68l58.8 34 58.8-34v-68zm41.4 92-41.5 23.9-41.4-23.9V47l41.5-23.9L112.3 47z" />
		<path d="m70.8 52.3 16.1 9.4L98.4 55 70.9 39.1 43.4 55v31.7l27.5 15.9 27.5-15.9L87 80.2l-16.1 9.3-16.1-9.3V61.7z" />
	</svg>
)
export default SvgSyCronos
